import { InteractLinkIcon, InteractShareIcon, MediaXIcon } from '@/client/assets';
import { Button, ButtonProps } from '@/client/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/client/components/ui/dropdown-menu';
import { cn } from '@/client/utils';
import { getTwitterShareUrl } from '@/libs/common/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

type ShareMarketProps = ButtonProps & {
  marketName: string;
  marketAddress: string;
  iconClassName?: string;
};
export const ShareMarket = ({ marketName, className, marketAddress, iconClassName, ...props }: ShareMarketProps) => {
  const { t } = useTranslation(['market']);
  const href = `${window.location.origin}/market/${marketAddress}`;
  const shareUrl = useMemo(
    () =>
      getTwitterShareUrl(`${marketName}
${t('im-trading-on-promethex-make-your-prediction')}
👇
${href}?t=${Math.ceil(Date.now() / 1e3)}
#DPIN #Prediction #PredictionMarket`),
    [href, marketName, t]
  );
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success(t('copied-to-clipboard'));
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" {...props} className={cn('size-9 rounded-full !ring-none', className)}>
          <InteractShareIcon className={cn('size-4 fill-current', iconClassName)} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="p-2 rounded-4 bg-card">
        <DropdownMenuItem className="cursor-pointer text-sm font-medium p-2 pr-3 active:bg-foreground/10">
          <a href={shareUrl} target="_blank" className="inline-flex gap-1 items-center">
            <MediaXIcon className="size-4 fill-current" />
            {t('share-to-x-twitter')}
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleCopy(href)}
          className="cursor-pointer text-sm font-medium p-2 pr-3 active:bg-foreground/10"
        >
          <InteractLinkIcon className="size-4 fill-current" />
          {t('copy-link')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
